"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var DialogTitle_1 = require("@mui/material/DialogTitle");
var DialogContent_1 = require("@mui/material/DialogContent");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var Dialog_1 = require("@mui/material/Dialog");
var Checkbox_1 = require("../../../components/Checkbox");
var FormGroup_1 = require("@mui/material/FormGroup");
var Typography_1 = require("@mui/material/Typography");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var components_1 = require("@athena-portal/components");
var Tree_1 = require("../../../components/Tree");
var GenerateDocumentsAction = /** @class */ (function (_super) {
    __extends(GenerateDocumentsAction, _super);
    function GenerateDocumentsAction(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (isChecked, document) {
            if (isChecked) {
                _this.setState(function (prevState) { return ({
                    selectedDocuments: __spreadArray(__spreadArray([], prevState.selectedDocuments, true), [document], false)
                }); });
            }
            else {
                _this.setState(function (prevState) { return ({
                    selectedDocuments: prevState.selectedDocuments.filter(function (value) { return value !== document; })
                }); });
            }
        };
        _this.toggleGenerateDocumentsPopupModal = function () {
            _this.setState(function (prevState) { return ({
                showGenerateDocumentsPopup: !prevState.showGenerateDocumentsPopup
            }); });
        };
        _this.generateDocuments = function () {
            _this.supportPortalService
                .generatePolicyDocuments(_this.state.selectedDocuments, _this.props.policyNumber, _this.props.interactionId)
                .subscribe();
            _this.setState({ selectedDocuments: [] });
        };
        _this.doConfirmation = function () {
            _this.supportPortalService.logAgentActivity(_this.props.userReference, { "action": "Generate Documents", "customer": _this.props.policyNumber }).subscribe();
            _this.generateDocuments();
            _this.toggleGenerateDocumentsPopupModal();
        };
        _this.state = {
            showGenerateDocumentsPopup: false,
            selectedDocuments: [],
        };
        return _this;
    }
    GenerateDocumentsAction.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.policyProduct) {
            this.supportPortalService
                .getAvailablePolicyDocuments(this.props.policyProduct, this.props.policyStatus)
                .pipe().subscribe(function (documentTemplates) {
                _this.setState({ documentTemplates: documentTemplates });
            });
            this.supportPortalService
                .getAvailablePolicyCommunications(this.props.policyProduct, this.props.policyStatus)
                .pipe().subscribe(function (communicationTemplates) {
                _this.setState({ communicationTemplates: communicationTemplates });
            });
        }
    };
    GenerateDocumentsAction.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(this.state.documentTemplates === undefined || this.state.communicationTemplates === undefined) ?
                        (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true }) :
                        (0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showGenerateDocumentsPopup, onClose: this.toggleGenerateDocumentsPopupModal, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { id: "alert-dialog-title", children: "Generate documents" }), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { className: "pb-0", children: (0, jsx_runtime_1.jsxs)(FormGroup_1.default, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "h6", children: "Documents" }), (_a = this.state.documentTemplates) === null || _a === void 0 ? void 0 : _a.map(function (document, id) {
                                                return (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "".concat(document.templateId), name: "document_".concat(document.templateId), label: _this.props.documents !== undefined && _this.getValue(document, _this.props.documents, undefined), className: "m-0", value: _this.state.selectedDocuments.includes(document.templateId), onChanged: function (isChecked) { return _this.handleChange(isChecked, document.templateId); } }, "".concat(document.templateId));
                                            }), (0, jsx_runtime_1.jsx)(Typography_1.default, { variant: "h6", className: "pt-4", children: "Communications" }), (_b = this.state.communicationTemplates) === null || _b === void 0 ? void 0 : _b.map(function (document, id) {
                                                return (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { id: "".concat(document.templateId), name: "document_".concat(document.templateId), label: _this.props.communications !== undefined && _this.getValue(document, undefined, _this.props.communications), className: "m-0", value: _this.state.selectedDocuments.includes(document.templateId), onChanged: function (isChecked) { return _this.handleChange(isChecked, document.templateId); } }, "".concat(document.templateId));
                                            })] }) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.doConfirmation, color: "primary", disabled: this.state.selectedDocuments.length === 0, children: "Generate documents" }), (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.toggleGenerateDocumentsPopupModal, color: "primary", children: "Cancel" })] })] }), (0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.toggleGenerateDocumentsPopupModal, children: "Generate documents" })] }) }));
    };
    GenerateDocumentsAction.prototype.getValue = function (documentTemplate, documentList, communicationList) {
        var date = "";
        if (documentList && documentList.length > 0) {
            var foundItem = documentList
                .sort(function (a, b) { return new Date(b.date).getTime() - new Date(a.date).getTime(); })
                .find(function (item) { return item.name.split("(")[0].split(".")[0] === documentTemplate.templateId; });
            if (foundItem) {
                date = foundItem.date;
            }
        }
        if (communicationList && communicationList.length > 0) {
            var foundItem = communicationList
                .sort(function (a, b) { return new Date(b.sentDate).getTime() - new Date(a.sentDate).getTime(); })
                .find(function (item) { return item.subject.split("(")[0].split(".")[0] === documentTemplate.templateId; });
            if (foundItem) {
                date = foundItem.sentDate;
            }
        }
        if (date !== "") {
            return documentTemplate.name + " [Generated:" + SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(date) + "]";
        }
        else {
            return documentTemplate.name;
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], GenerateDocumentsAction.prototype, "supportPortalService", void 0);
    GenerateDocumentsAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR", "Support"),
        __metadata("design:paramtypes", [Object])
    ], GenerateDocumentsAction);
    return GenerateDocumentsAction;
}(React.Component));
exports.default = GenerateDocumentsAction;
//# sourceMappingURL=GenerateDocumentsAction.js.map